import { createValidator, ErrorObject, required } from 'util/validation'

import { hasAnySim } from '../../utils-consultaSeguimento'
import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta04Model } from './model-consultaSeguimentoPergunta04'

export const validatorConsultaSeguimentoPergunta04 = createValidator<ConsultaSeguimentoPergunta04Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_04_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta04Model, errors: ErrorObject<ConsultaSeguimentoPergunta04Model>) => {
    if (hasAnySim(values?.PERGUNTA_04_GOSTA_DE_SUBIR_EM)) {
      return errors
    }
    errors.PERGUNTA_04_GOSTA_DE_SUBIR_EM = required(values?.PERGUNTA_04_GOSTA_DE_SUBIR_EM)
    return errors
  }
)
